/**
 * Map shortlisted aircraft to bid option payload format
 */
export const mapAircraftToPayload = (aircraft) => {
  const operatorCost = parseFloat(aircraft.total_price || aircraft.price || 0);
  const hasFinalPrice = aircraft.final_price && parseFloat(aircraft.final_price) !== operatorCost;

  return {
    aircraft_id: aircraft.aircraft_id,
    operator_id: aircraft.operator_id || aircraft.operator?.operator_id,
    base_price: aircraft.base_price || "0.00",
    fuel_cost: aircraft.fuel_cost || "0.00",
    landing_fees: aircraft.landing_fees || "0.00",
    crew_fees: aircraft.crew_fees || "0.00",
    catering_cost: aircraft.catering_cost || "0.00",
    ground_transport: aircraft.ground_transport || "0.00",
    other_fees: aircraft.other_fees || "0.00",
    total_price: aircraft.total_price || aircraft.price || "0.00",
    broker_markup: aircraft.broker_markup || null,
    final_price: hasFinalPrice ? aircraft.final_price : null,
    federal_excise_tax: aircraft.federal_excise_tax || null,
    segment_tax: aircraft.segment_tax || null,
    platform_fee: aircraft.platform_fee || null,
    is_recommended: aircraft.is_recommended ?? true,
    recommendation_reason: aircraft.recommendation_reason || ".",
    availability_confirmed: aircraft.availability_confirmed ?? true,
    shortlisted: true,
    risk_level: aircraft.risk_level || "LOW",
    trust_score: aircraft.trust_score || "0.00",
    estimated_flight_time: aircraft.estimated_flight_time || 0,
    aircraft_features: aircraft.aircraft_features || {
      beds: aircraft.beds || 0,
      wifi: aircraft.wifi || false,
      entertainment: aircraft.entertainment || false
    },
    operator: aircraft.operator,
    aircraft: aircraft.aircraft || aircraft,
    bid_option_id: aircraft.bid_option_id || aircraft.aircraft_id,
  };
};

/**
 * Transform backend bid data to frontend format
 */
export const transformBidData = (backendBid) => {
  // Map backend status to frontend status
  const statusMap = {
    'DRAFT': 'pending',
    'SENT': 'pending',
    'ACCEPTED': 'accepted',
    'REJECTED': 'rejected',
  };

  const statusTextMap = {
    'DRAFT': 'Draft',
    'SENT': 'Pending Quote',
    'ACCEPTED': 'Accepted',
    'REJECTED': 'Rejected',
  };

  // Build flights array from departure and return dates
  const flights = [
    {
      id: `${backendBid.bid_id}-leg-1`,
      origin: backendBid.departure_airport,
      destination: backendBid.arrival_airport,
      duration: backendBid.estimated_flight_time || 'N/A',
      date: backendBid.departure_date,
    },
  ];

  // Add return flight if exists
  if (backendBid.return_date) {
    flights.push({
      id: `${backendBid.bid_id}-leg-2`,
      origin: backendBid.arrival_airport,
      destination: backendBid.departure_airport,
      duration: backendBid.estimated_flight_time || 'N/A',
      date: backendBid.return_date,
    });
  }

  return {
    id: backendBid.bid_id,
    client: {
      id: backendBid.created_by,
      firstName: (backendBid.client_name || '').split(/\s+/)[0] || '',
      lastName: (backendBid.client_name || '').split(/\s+/).slice(1).join(' ') || '',
      email: backendBid.client_email,
      phone: backendBid.client_phone,
      avatarUrl: null,
      isVerified: true,
      company: backendBid.client_name, // Backend doesn't have separate company field
    },
    flights,
    passengers: backendBid.passenger_count,
    status: statusMap[backendBid.status] || 'pending',
    statusText: statusTextMap[backendBid.status] || 'Pending Quote',
    statusCount: 1,
    hasAttachments: false,
    isShortlisted: backendBid.shortlisted || false,
    createdAt: backendBid.created_at,
    updatedAt: backendBid.updated_at,
    notes: backendBid.notes,
    estimatedCost: backendBid.total_amount,
    currency: backendBid.currency || 'USD',
  };
};
